// @flow
import React from 'react';
import classNames from 'classnames';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  title: string,
  isActive: boolean,
  onClick: () => void,
  color: 'red' | 'yellow' | 'green',
};

export const ButtonFilterItem = (props: Props) => {
  const { isActive, onClick, title, color } = props;
  const className = classNames('button-filter-item', color, {
    active: isActive,
  });

  return (
    <div className={className} onClick={onClick}>
      <span className={'icon-dot'} />
      {title}
    </div>
  );
};
